import { useHistory } from 'react-router'
import { Button } from 'antd'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ProfileRoutes } from 'enum/routes'
import { useEditProfile } from '../../context'
import { Wrapper } from './styled'

export const Buttons = () => {
  const tRelative = useTranslationRankmi({
    prefix: 'configuration.lmsProfiles.edit',
  })

  const history = useHistory()

  const {
    updatedData,
    form: { formState },
    onSave,
  } = useEditProfile()

  const goToMain = () => {
    history.push(ProfileRoutes.MAIN)
  }

  return (
    <Wrapper>
      <Button onClick={goToMain}>{tRelative('buttons.cancel')}</Button>
      <Button
        disabled={!formState.isValid || !updatedData}
        onClick={async () => {
          await onSave()
          goToMain()
        }}
      >
        {tRelative('buttons.saveV2')}
      </Button>
    </Wrapper>
  )
}
